<section class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-gap-6 tw-px-4 tw-py-6 lg:tw-px-16" id="webhook-logs">
  <div class="tw-flex tw-flex-col tw-gap-1">
    <h2 class="tw-font-inter tw-text-xl tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 lg:tw-text-[28px] lg:tw-leading-tight">
      {{ logsTitle() }} {{ 'v2.orgSettings.webhooks.webhookLogsTitleSuffix' | translate }}
    </h2>
    <p class="tw-font-inter tw-text-sm tw-text-gray-500 dark:tw-text-gray-300 lg:tw-text-base">
      {{ 'v2.orgSettings.webhooks.webhookLogsDescription' | translate }}
    </p>
  </div>

  @if (isLoading()) {
  <div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-4 lg:tw-flex-row" role="status" [attr.aria-label]="'v2.orgSettings.webhooks.webhookLogs' | translate">
    <div
      class="tw-flex tw-w-full tw-h-[760px] tw-flex-col tw-gap-4 tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-white tw-p-4 dark:tw-border-gray-600 dark:tw-bg-gray-900/20 lg:tw-w-[42%] lg:tw-flex-1"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '120px',
          height: '24px',
          'border-radius': '6px',
          backgroundColor: getSkeletonTheme().backgroundColor,
          color: getSkeletonTheme().color,
          marginBottom: '0'
        }"
        animation="pulse"
      ></ngx-skeleton-loader>

      <div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-3">
        @for (_skeleton of [1, 2, 3, 4, 5, 6, 7]; track $index) {
        <div class="tw-flex tw-w-full tw-flex-col tw-gap-3 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-px-4 tw-py-3 dark:tw-border-gray-600 dark:tw-bg-gray-800">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
            <ngx-skeleton-loader
              count="1"
              class="tw-flex-1"
              [theme]="{
                width: '100%',
                height: '16px',
                'border-radius': '4px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color,
                marginBottom: '0'
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '64px',
                height: '20px',
                'border-radius': '4px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color,
                marginBottom: '0'
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '14px',
              'border-radius': '4px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
        }
      </div>
    </div>

    <div
      class="tw-hidden tw-h-[760px] tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-6 tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-white tw-p-6 dark:tw-border-gray-600 dark:tw-bg-gray-900/20 lg:tw-flex"
    >
      <div class="tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-3.5">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '140px',
              height: '24px',
              'border-radius': '6px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '72px',
              height: '32px',
              'border-radius': '6px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '18rem',
            'border-radius': '12px',
            backgroundColor: getSkeletonTheme().backgroundColor,
            color: getSkeletonTheme().color,
            marginBottom: '0'
          }"
          animation="pulse"
        ></ngx-skeleton-loader>
      </div>

      <div class="tw-h-px tw-bg-gray-200 dark:tw-bg-gray-600"></div>

      <div class="tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-3.5">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '180px',
              height: '24px',
              'border-radius': '6px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '72px',
              height: '32px',
              'border-radius': '6px',
              backgroundColor: getSkeletonTheme().backgroundColor,
              color: getSkeletonTheme().color,
              marginBottom: '0'
            }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '100%',
            height: '15rem',
            'border-radius': '12px',
            backgroundColor: getSkeletonTheme().backgroundColor,
            color: getSkeletonTheme().color,
            marginBottom: '0'
          }"
          animation="pulse"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
  } @else if (!deliveries().length) {
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-6 tw-py-10 tw-text-center">
    <div class="tw-flex tw-h-52 tw-w-80 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100 dark:tw-bg-gray-700 lg:tw-h-96 lg:tw-w-[600px]">
      <img src="assets/images/v2/webhook-logs-empty.svg" alt="" class="tw-h-full tw-w-full" />
    </div>
    <div class="tw-flex tw-max-w-md tw-flex-col tw-gap-2">
      <h3 class="tw-font-inter tw-text-xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100">
        {{ 'v2.orgSettings.webhooks.noWebhookDeliveriesYet' | translate }}
      </h3>
      <p class="tw-font-inter tw-text-base tw-font-medium tw-text-gray-500 dark:tw-text-gray-300">
        {{ 'v2.orgSettings.webhooks.noWebhookDeliveriesDescription' | translate }}
      </p>
    </div>
  </div>
  } @else {
  <div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-4 lg:tw-flex-row">
    <ng-container *ngTemplateOutlet="deliveriesPanel"></ng-container>

    @if (selectedDeliveryPreview(); as preview) {
    <div
      class="tw-hidden tw-h-[760px] tw-min-w-0 tw-flex-1 tw-flex-col tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-white tw-p-6 dark:tw-border-gray-600 dark:tw-bg-gray-900/20 lg:tw-flex tw-justify-between"
    >
      <ng-container *ngTemplateOutlet="deliveryPreview; context: { $implicit: preview, mobile: false }"></ng-container>
    </div>
    }
  </div>
  } @if (mobileView() === 'preview' && selectedDeliveryPreview(); as preview) {
  <div #mobilePreviewOverlay class="webhook-logs-mobile-preview-overlay tw-fixed tw-inset-0 tw-z-[1500] lg:tw-hidden" role="dialog" aria-modal="true">
    <div class="tw-absolute tw-inset-0 tw-bg-gray-900/50" (click)="closeMobilePreview()"></div>

    <div class="webhook-logs-mobile-preview tw-absolute tw-inset-y-0 tw-end-0 tw-flex tw-h-dvh tw-w-[92%] tw-max-w-full tw-flex-col tw-bg-gray-50 tw-shadow-xl dark:tw-bg-gray-900">
      <header class="tw-flex tw-shrink-0 tw-items-start tw-justify-between tw-gap-4 tw-px-4 tw-py-4">
        <div class="tw-flex tw-min-w-0 tw-flex-col tw-gap-1">
          <h3 class="tw-font-inter tw-text-lg tw-font-bold tw-text-gray-900 dark:tw-text-gray-100">{{ preview.trigger }}</h3>
          <p class="tw-font-inter tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-700 dark:tw-text-gray-300">{{ preview.deliveredAt }}</p>
        </div>

        <button
          type="button"
          class="tw-inline-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-text-gray-500 hover:tw-text-gray-700 dark:tw-text-gray-400 dark:hover:tw-text-gray-200"
          [attr.aria-label]="'v2.orgSettings.webhooks.closePreview' | translate"
          (click)="closeMobilePreview()"
        >
          <svg class="tw-h-4 tw-w-4" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M2.92 2.92L11.08 11.08M11.08 2.92L2.92 11.08" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>
      </header>

      <div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-6 tw-overflow-y-auto tw-px-4 tw-pb-6">
        <ng-container *ngTemplateOutlet="deliveryPreview; context: { $implicit: preview, mobile: true }"></ng-container>
      </div>
    </div>
  </div>
  }
</section>

<ng-template #deliveriesPanel>
  <div
    class="tw-flex tw-w-full tw-h-[760px] tw-flex-col tw-gap-4 tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-white tw-p-4 dark:tw-border-gray-600 dark:tw-bg-gray-900/20 lg:tw-w-[42%] lg:tw-flex-1"
  >
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <h3 class="tw-font-inter tw-text-lg tw-font-bold tw-text-gray-900 dark:tw-text-gray-100">
        {{ 'v2.orgSettings.webhooks.deliveries' | translate }}
      </h3>

      @if (lastPage() > 1) {
      <div class="tw-inline-flex tw-overflow-hidden tw-rounded tw-border tw-border-gray-300 dark:tw-border-gray-600">
        <button
          type="button"
          class="webhook-logs-pagination-btn tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-border-e tw-border-gray-300 tw-bg-white tw-text-gray-500 dark:tw-border-gray-600 dark:tw-bg-gray-800"
          [disabled]="currentPage() <= 1"
          (click)="goToPage(currentPage() - 1)"
        >
          <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M8.75 2.92L4.67 7L8.75 11.08" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        @for (page of pageNumbers(); track page) { @if (page === 'ellipsis') {
        <span
          class="tw-inline-flex tw-h-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-e tw-border-gray-300 tw-bg-white tw-px-2 tw-text-sm tw-text-gray-500 dark:tw-border-gray-600 dark:tw-bg-gray-800"
          >...</span
        >
        } @else {
        <button
          type="button"
          class="webhook-logs-pagination-btn tw-inline-flex tw-h-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-e tw-border-gray-300 tw-px-2 tw-text-sm tw-font-medium last:tw-border-e-0"
          [ngClass]="
            page === currentPage()
              ? 'tw-bg-blue-50 tw-text-blue-700 dark:tw-bg-blue-900/30 dark:tw-text-blue-300'
              : 'tw-bg-white tw-text-gray-500 dark:tw-bg-gray-800 dark:tw-text-gray-300'
          "
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>
        } }

        <button
          type="button"
          class="webhook-logs-pagination-btn tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-bg-white tw-text-gray-500 dark:tw-bg-gray-800"
          [disabled]="currentPage() >= lastPage()"
          (click)="goToPage(currentPage() + 1)"
        >
          <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M5.25 2.92L9.33 7L5.25 11.08" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      }
    </div>

    <div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-3 tw-overflow-y-auto">
      @for (item of deliveryListItems(); track item.delivery.id) {
      <div
        class="tw-flex tw-w-full tw-flex-col tw-gap-3 tw-rounded-lg tw-border tw-px-4 tw-py-3 tw-text-start tw-transition-colors"
        [ngClass]="
          selectedDeliveryId() === item.delivery.id
            ? 'tw-border-blue-600 tw-bg-blue-50 dark:tw-border-blue-500 dark:tw-bg-blue-900/20'
            : 'tw-border-gray-200 tw-bg-gray-50 hover:tw-bg-gray-100 dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:hover:tw-bg-gray-700/60'
        "
      >
        @if (isMobileLayout()) {
        <div class="tw-flex tw-flex-col tw-gap-3">
          <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
            <span
              class="tw-font-inter tw-text-sm tw-font-semibold"
              [ngClass]="selectedDeliveryId() === item.delivery.id ? 'tw-text-gray-900 dark:tw-text-gray-100' : 'tw-text-gray-700 dark:tw-text-gray-800'"
              >{{ item.trigger }}</span
            >
            <span [ngClass]="selectedDeliveryId() === item.delivery.id ? 'tw-text-gray-900 dark:tw-text-gray-100' : 'tw-text-gray-700 dark:tw-text-gray-800'">-</span>
            <span
              class="tw-font-inter tw-text-sm tw-font-semibold"
              [ngClass]="selectedDeliveryId() === item.delivery.id ? 'tw-text-gray-900 dark:tw-text-gray-100' : 'tw-text-gray-700 dark:tw-text-gray-800'"
              >{{ item.deliveredAt }}</span
            >
          </div>

          <p class="tw-break-all tw-font-inter tw-text-sm tw-text-gray-900 dark:tw-text-gray-400">{{ item.webhookUrl }}</p>

          <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
            <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              @if (item.isSuccess) {
              <span class="tw-inline-flex tw-rounded tw-bg-green-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-green-800 dark:tw-bg-green-900/30 dark:tw-text-green-300">
                {{ 'v2.orgSettings.webhooks.deliverySuccess' | translate }}
              </span>
              } @else {
              <span class="tw-inline-flex tw-rounded tw-bg-red-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-red-800 dark:tw-bg-red-900/30 dark:tw-text-red-300">
                {{ 'v2.orgSettings.webhooks.deliveryFailed' | translate }}
              </span>
              } @if (item.delivery.retry_count > 0) {
              <span
                class="tw-inline-flex tw-items-center tw-gap-1 tw-rounded tw-bg-gray-300 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-bg-gray-700 dark:tw-text-gray-100"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path
                    d="M9.07391 4.5C8.79229 4.5 8.56465 4.724 8.56465 5C8.56465 6.93 6.96507 8.5 4.99984 8.5C4.05873 8.5 3.16803 8.13 2.51007 7.5H3.98132C4.26294 7.5 4.49058 7.276 4.49058 7C4.49058 6.724 4.26294 6.5 3.98132 6.5H1.56386C1.46303 6.4795 1.35762 6.4915 1.25729 6.535C1.24812 6.5385 1.23845 6.54 1.22928 6.544C1.22266 6.5475 1.21553 6.547 1.20891 6.5505C1.19516 6.5585 1.18752 6.5715 1.17428 6.58C1.02812 6.6685 0.925763 6.8195 0.925763 7V9.5C0.925763 9.776 1.1534 10 1.43502 10C1.71664 10 1.94428 9.776 1.94428 9.5V8.34C2.77437 9.0705 3.85655 9.5 4.99984 9.5C7.52729 9.5 9.58317 7.481 9.58317 5C9.58317 4.724 9.35553 4.5 9.07391 4.5Z"
                    fill="currentColor"
                  />
                  <path
                    d="M1.43502 5C1.43502 3.07 3.03461 1.5 4.99984 1.5C5.94095 1.5 6.83164 1.87 7.48961 2.5H6.01836C5.73674 2.5 5.5091 2.724 5.5091 3C5.5091 3.276 5.73674 3.5 6.01836 3.5H8.43479C8.53613 3.521 8.64257 3.5085 8.74289 3.4645C8.75206 3.461 8.76174 3.4595 8.7709 3.4555C8.77752 3.452 8.78465 3.4525 8.79127 3.449C8.80502 3.441 8.81266 3.428 8.8259 3.4195C8.97155 3.3315 9.07391 3.1805 9.07391 3V0.5C9.07391 0.224 8.84627 0 8.56465 0C8.28303 0 8.05539 0.224 8.05539 0.5V1.66C7.2253 0.9295 6.14312 0.5 4.99984 0.5C2.47238 0.5 0.416504 2.519 0.416504 5C0.416504 5.276 0.644143 5.5 0.925763 5.5C1.20738 5.5 1.43502 5.276 1.43502 5Z"
                    fill="currentColor"
                  />
                </svg>
                {{ item.delivery.retry_count }}
              </span>
              }
            </div>

            <button
              type="button"
              class="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1 tw-text-sm tw-font-medium tw-text-blue-600"
              (click)="openMobilePreview(item.delivery, $event)"
            >
              {{ 'v2.orgSettings.webhooks.preview' | translate }}
              <svg class="tw-h-4 tw-w-4 tw-text-blue-600" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M5.25 2.92L9.33 7L5.25 11.08" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        } @else {
        <div class="tw-flex tw-cursor-pointer tw-flex-col tw-gap-2" (click)="selectDelivery(item.delivery)">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
            <div class="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2">
              <span
                class="tw-font-inter tw-text-sm tw-font-semibold"
                [ngClass]="selectedDeliveryId() === item.delivery.id ? 'tw-text-gray-900 dark:tw-text-gray-100' : 'tw-text-gray-700 dark:tw-text-gray-800'"
                >{{ item.trigger }}</span
              >
              <span [ngClass]="selectedDeliveryId() === item.delivery.id ? 'tw-text-gray-900 dark:tw-text-gray-100' : 'tw-text-gray-700 dark:tw-text-gray-800'">-</span>
              <span
                class="tw-font-inter tw-text-sm tw-font-semibold"
                [ngClass]="selectedDeliveryId() === item.delivery.id ? 'tw-text-gray-900 dark:tw-text-gray-100' : 'tw-text-gray-700 dark:tw-text-gray-800'"
                >{{ item.deliveredAt }}</span
              >
            </div>

            <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-2">
              @if (item.delivery.retry_count > 0) {
              <span
                class="tw-inline-flex tw-items-center tw-gap-1 tw-rounded tw-bg-gray-300 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-gray-800 dark:tw-bg-gray-700 dark:tw-text-gray-100"
                [ngxTippy]="'v2.orgSettings.webhooks.retries' | translate"
                [tippyProps]="retriesTippyProps"
                (click)="$event.stopPropagation()"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path
                    d="M9.07391 4.5C8.79229 4.5 8.56465 4.724 8.56465 5C8.56465 6.93 6.96507 8.5 4.99984 8.5C4.05873 8.5 3.16803 8.13 2.51007 7.5H3.98132C4.26294 7.5 4.49058 7.276 4.49058 7C4.49058 6.724 4.26294 6.5 3.98132 6.5H1.56386C1.46303 6.4795 1.35762 6.4915 1.25729 6.535C1.24812 6.5385 1.23845 6.54 1.22928 6.544C1.22266 6.5475 1.21553 6.547 1.20891 6.5505C1.19516 6.5585 1.18752 6.5715 1.17428 6.58C1.02812 6.6685 0.925763 6.8195 0.925763 7V9.5C0.925763 9.776 1.1534 10 1.43502 10C1.71664 10 1.94428 9.776 1.94428 9.5V8.34C2.77437 9.0705 3.85655 9.5 4.99984 9.5C7.52729 9.5 9.58317 7.481 9.58317 5C9.58317 4.724 9.35553 4.5 9.07391 4.5Z"
                    fill="currentColor"
                  />
                  <path
                    d="M1.43502 5C1.43502 3.07 3.03461 1.5 4.99984 1.5C5.94095 1.5 6.83164 1.87 7.48961 2.5H6.01836C5.73674 2.5 5.5091 2.724 5.5091 3C5.5091 3.276 5.73674 3.5 6.01836 3.5H8.43479C8.53613 3.521 8.64257 3.5085 8.74289 3.4645C8.75206 3.461 8.76174 3.4595 8.7709 3.4555C8.77752 3.452 8.78465 3.4525 8.79127 3.449C8.80502 3.441 8.81266 3.428 8.8259 3.4195C8.97155 3.3315 9.07391 3.1805 9.07391 3V0.5C9.07391 0.224 8.84627 0 8.56465 0C8.28303 0 8.05539 0.224 8.05539 0.5V1.66C7.2253 0.9295 6.14312 0.5 4.99984 0.5C2.47238 0.5 0.416504 2.519 0.416504 5C0.416504 5.276 0.644143 5.5 0.925763 5.5C1.20738 5.5 1.43502 5.276 1.43502 5Z"
                    fill="currentColor"
                  />
                </svg>
                {{ item.delivery.retry_count }}
              </span>
              } @if (item.isSuccess) {
              <span class="tw-inline-flex tw-rounded tw-bg-green-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-green-800 dark:tw-bg-green-900/30 dark:tw-text-green-300">
                {{ 'v2.orgSettings.webhooks.deliverySuccess' | translate }}
              </span>
              } @else {
              <span class="tw-inline-flex tw-rounded tw-bg-red-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-red-800 dark:tw-bg-red-900/30 dark:tw-text-red-300">
                {{ 'v2.orgSettings.webhooks.deliveryFailed' | translate }}
              </span>
              }
            </div>
          </div>

          <p class="tw-break-all tw-font-inter tw-text-sm tw-text-gray-900 dark:tw-text-gray-400">{{ item.webhookUrl }}</p>
        </div>
        }
      </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #deliveryPreview let-preview let-mobile="mobile">
  <div class="tw-flex tw-flex-col tw-gap-4">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3.5">
      <h4 class="tw-font-inter tw-text-base tw-font-bold tw-text-gray-900 dark:tw-text-gray-100 lg:tw-text-lg">
        {{ 'v2.orgSettings.webhooks.payloadPreview' | translate }}
      </h4>
      <button
        type="button"
        class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-text-blue-600"
        [ngClass]="
          mobile
            ? 'tw-h-8 tw-w-8 tw-rounded-md tw-border tw-border-blue-600'
            : 'tw-h-8 tw-gap-2 tw-rounded-md tw-border tw-border-blue-600 tw-px-2.5 tw-text-sm tw-font-medium hover:tw-bg-blue-50 dark:hover:tw-bg-blue-900/20'
        "
        [attr.aria-label]="'v2.orgSettings.webhooks.copy' | translate"
        (click)="copyToClipboard(preview.delivery.request?.body)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none" aria-hidden="true">
          <path
            d="M8.89475 5.75118e-06H5.90168C5.67649 -0.000586605 5.45342 0.044585 5.24538 0.132906C5.03735 0.221226 4.84848 0.350941 4.68971 0.514542L4.28572 0.927225C4.22237 0.995968 4.17646 1.07958 4.15201 1.17074H6.60909C7.2101 1.17646 7.78434 1.42621 8.20579 1.86519C8.62724 2.30417 8.86145 2.89651 8.85704 3.5122V9.36586H8.89475C9.19271 9.36032 9.47637 9.23396 9.68353 9.0145C9.8907 8.79504 10.0045 8.50038 9.99987 8.19513V1.17074C10.0045 0.865486 9.8907 0.570826 9.68353 0.351364C9.47637 0.131903 9.19271 0.00554845 8.89475 5.75118e-06Z"
            fill="#1C64F2"
          />
          <path
            d="M3.14289 5.26828V2.34146C3.14364 2.25614 3.16317 2.17211 3.20003 2.0956C2.82194 2.17642 2.47515 2.3687 2.20234 2.64877L0.585805 4.30477C0.328154 4.57043 0.147208 4.90388 0.0629606 5.26828H3.14289Z"
            fill="#1C64F2"
          />
          <path
            d="M6.60909 2.04878H4.19829C4.25285 2.13639 4.28307 2.23758 4.28572 2.34146V5.26829C4.28572 5.57879 4.16531 5.87657 3.95099 6.09612C3.73667 6.31568 3.44598 6.43902 3.14289 6.43902H0.00010616V10.5366C-0.00447394 10.9194 0.139309 11.2884 0.399926 11.5627C0.660543 11.837 1.01672 11.9943 1.39036 12H6.60909C6.98278 11.9943 7.33901 11.8371 7.59972 11.5627C7.86043 11.2884 8.00434 10.9194 7.99991 10.5366V3.51219C8.00434 3.12937 7.86043 2.76036 7.59972 2.48604C7.33901 2.21173 6.98278 2.05449 6.60909 2.04878Z"
            fill="#1C64F2"
          />
        </svg>
        @if (!mobile) {
        {{ 'v2.orgSettings.webhooks.copy' | translate }}
        }
      </button>
    </div>

    <div
      class="webhooks-list-scroll tw-min-h-0 tw-overflow-y-auto tw-rounded-xl tw-border tw-border-gray-200 tw-p-4 dark:tw-border-gray-600"
      [ngClass]="mobile ? 'tw-max-h-56 tw-h-56 tw-bg-white dark:tw-bg-gray-800' : 'tw-max-h-[18rem] tw-h-[18rem] tw-bg-gray-50 dark:tw-bg-gray-800'"
    >
      <pre class="webhook-logs-json tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">{{ preview.formattedRequestBody }}</pre>
    </div>
  </div>

  <div class="tw-h-px tw-bg-gray-200 dark:tw-bg-gray-600"></div>

  <div class="tw-flex tw-flex-col tw-gap-4">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3.5">
      <div class="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2">
        <h4 class="tw-font-inter tw-text-base tw-font-bold tw-text-gray-900 dark:tw-text-gray-100 lg:tw-text-lg">
          {{ 'v2.orgSettings.webhooks.requestResponse' | translate }}
        </h4>

        @if (preview.isSuccess) {
        <span class="tw-inline-flex tw-rounded tw-bg-green-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-green-800 dark:tw-bg-green-900/30 dark:tw-text-green-300">
          {{ 'v2.orgSettings.webhooks.deliverySuccess' | translate }}
        </span>
        } @else {
        <span class="tw-inline-flex tw-rounded tw-bg-red-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-red-800 dark:tw-bg-red-900/30 dark:tw-text-red-300">
          {{ 'v2.orgSettings.webhooks.deliveryFailed' | translate }}
        </span>
        } @if (preview.delivery.response_status != null) {
        <span
          class="tw-inline-flex tw-rounded tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium"
          [ngClass]="
            preview.isSuccess
              ? 'tw-bg-green-100 tw-text-green-800 dark:tw-bg-green-900/30 dark:tw-text-green-300'
              : 'tw-bg-red-100 tw-text-red-800 dark:tw-bg-red-900/30 dark:tw-text-red-300'
          "
        >
          {{ preview.delivery.response_status }}
        </span>
        }
      </div>

      <button
        type="button"
        class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-text-blue-600"
        [ngClass]="
          mobile
            ? 'tw-h-8 tw-w-8 tw-rounded-md tw-border tw-border-blue-600'
            : 'tw-h-8 tw-gap-2 tw-rounded-md tw-border tw-border-blue-600 tw-px-2.5 tw-text-sm tw-font-medium hover:tw-bg-blue-50 dark:hover:tw-bg-blue-900/20'
        "
        [attr.aria-label]="'v2.orgSettings.webhooks.copy' | translate"
        (click)="copyToClipboard(preview.delivery.response?.raw)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none" aria-hidden="true">
          <path
            d="M8.89475 5.75118e-06H5.90168C5.67649 -0.000586605 5.45342 0.044585 5.24538 0.132906C5.03735 0.221226 4.84848 0.350941 4.68971 0.514542L4.28572 0.927225C4.22237 0.995968 4.17646 1.07958 4.15201 1.17074H6.60909C7.2101 1.17646 7.78434 1.42621 8.20579 1.86519C8.62724 2.30417 8.86145 2.89651 8.85704 3.5122V9.36586H8.89475C9.19271 9.36032 9.47637 9.23396 9.68353 9.0145C9.8907 8.79504 10.0045 8.50038 9.99987 8.19513V1.17074C10.0045 0.865486 9.8907 0.570826 9.68353 0.351364C9.47637 0.131903 9.19271 0.00554845 8.89475 5.75118e-06Z"
            fill="#1C64F2"
          />
          <path
            d="M3.14289 5.26828V2.34146C3.14364 2.25614 3.16317 2.17211 3.20003 2.0956C2.82194 2.17642 2.47515 2.3687 2.20234 2.64877L0.585805 4.30477C0.328154 4.57043 0.147208 4.90388 0.0629606 5.26828H3.14289Z"
            fill="#1C64F2"
          />
          <path
            d="M6.60909 2.04878H4.19829C4.25285 2.13639 4.28307 2.23758 4.28572 2.34146V5.26829C4.28572 5.57879 4.16531 5.87657 3.95099 6.09612C3.73667 6.31568 3.44598 6.43902 3.14289 6.43902H0.00010616V10.5366C-0.00447394 10.9194 0.139309 11.2884 0.399926 11.5627C0.660543 11.837 1.01672 11.9943 1.39036 12H6.60909C6.98278 11.9943 7.33901 11.8371 7.59972 11.5627C7.86043 11.2884 8.00434 10.9194 7.99991 10.5366V3.51219C8.00434 3.12937 7.86043 2.76036 7.59972 2.48604C7.33901 2.21173 6.98278 2.05449 6.60909 2.04878Z"
            fill="#1C64F2"
          />
        </svg>
        @if (!mobile) {
        {{ 'v2.orgSettings.webhooks.copy' | translate }}
        }
      </button>
    </div>

    <div
      class="webhooks-list-scroll tw-min-h-0 tw-overflow-y-auto tw-rounded-xl tw-border tw-border-gray-200 tw-p-4 dark:tw-border-gray-600"
      [ngClass]="mobile ? 'tw-max-h-56 tw-h-56 tw-bg-white dark:tw-bg-gray-800' : 'tw-max-h-[18rem] tw-h-[18rem] tw-bg-gray-50 dark:tw-bg-gray-800'"
    >
      <pre class="webhook-logs-json tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">{{ preview.formattedResponseRaw }}</pre>
    </div>
  </div>
</ng-template>
